import { useEffect } from 'react';

export const useSelectSearchMenuVisibility = (
  selectSearchMenuRef: React.RefObject<HTMLDivElement>,
  dropdown: React.RefObject<{ close: () => void; open: () => void }>
): void => {
  useEffect(() => {
    const close = (e: Event): void => {
      if (
        selectSearchMenuRef.current &&
        e.target instanceof Node &&
        selectSearchMenuRef.current.contains(e.target)
      ) {
        return;
      }

      dropdown.current?.close();
    };

    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);

    return () => {
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [dropdown, selectSearchMenuRef]);
};
